import BaseDto from '../../_common/BaseDto';

class ConversationWindowDtoBuilder {
    withUuid(uuid) {
        this.uuid = uuid;
        return this;
    }

    withIsClosed(isClosed) {
        this.is_closed = isClosed;
        return this;
    }

    withAccount(account) {
        this.account = account;
        return this;
    }

    withInvoiced(invoiced) {
        this.invoiced = invoiced;
        return this;
    }

    withConversation(conversation) {
        this.conversation = conversation;
        return this;
    }

    withSentiment(sentiment) {
        this.sentiment = sentiment;
        return this;
    }

    withHumanParticipation(humanParticipation) {
        this.human_participation = humanParticipation;
        return this;
    }

    withSummary(summary) {
        this.summary = summary;
        return this;
    }

    /** Cuándo se escribió el resumen. Sin esto no se puede saber si ha caducado. */
    withSummaryDateCreated(summaryDateCreated) {
        this.summary_date_created = summaryDateCreated;
        return this;
    }

    withSummaryTranslated(summaryTranslated) {
        this.summary_translated = summaryTranslated;
        return this;
    }

    withHasSummary(hasSummary) {
        this.has_summary = hasSummary;
        return this;
    }

    withTopic(topic) {
        this.topic = topic;
        return this;
    }

    withChannelType(channelType) {
        this.channel_type = channelType;
        return this;
    }

    withOwner(owner) {
        this.owner = owner;
        return this;
    }

    withOpenedByCampaign(openedByCampaign) {
        this.opened_by_campaign = openedByCampaign;
        return this;
    }

    withTags(tags) {
        this.tags = tags;
        return this;
    }

    withDateCreated(dateCreated) {
        this.date_created = dateCreated;
        return this;
    }

    withDateClosed(dateClosed) {
        this.date_closed = dateClosed;
        return this;
    }

    build() {
        return new ConversationWindowDto(this);
    }
}

/**
 * @class ConversationWindowDto
 * @description DTO for ConversationWindow
 * @param uuid - The UUID of the conversation window
 * @param is_closed - Whether the conversation window is closed
 * @param account - The account of the conversation window
 * @param invoiced - Whether the conversation window is invoiced
 * @param conversation - The conversation of the conversation window
 * @param sentiment - The sentiment of the conversation window
 * @param human_participation - Whether the conversation window has human participation
 * @param summary - The summary of the conversation window (may be omitted in the lightweight list)
 * @param has_summary - Whether a consolidated summary exists, without transferring its text
 * @param opened_by_campaign - Whether the window was opened by a marketing campaign
 * @param topic - The topic of the conversation window
 * @param channel_type - The channel type of the conversation window
 * @param owner - The owner of the conversation window
 * @param tags - The tags of the conversation window
 * @param date_created - The date created of the conversation window
 * @param date_closed - The date closed of the conversation window
 */

class ConversationWindowDto extends BaseDto {
    constructor(builder) {
        super();
        this.uuid = builder.uuid;
        this.is_closed = builder.is_closed;
        this.account = builder.account;
        this.invoiced = builder.invoiced;
        this.conversation = builder.conversation;
        this.sentiment = builder.sentiment;
        this.human_participation = builder.human_participation;
        this.summary = builder.summary;
        this.summary_translated = builder.summary_translated;
        this.summary_date_created = builder.summary_date_created;
        this.has_summary = typeof builder.has_summary === 'boolean' ? builder.has_summary : Boolean(builder.summary);
        this.topic = builder.topic;
        this.channel_type = builder.channel_type;
        this.owner = builder.owner;
        this.tags = builder.tags;
        this.opened_by_campaign = builder.opened_by_campaign === true;
        this.date_created = builder.date_created;
        this.date_closed = builder.date_closed;
    }

    static get Builder() {
        return ConversationWindowDtoBuilder;
    }
}

export default ConversationWindowDto;
